import axiosInstance from './axiosInstance';

export type Appointment = {
  id: string;
  tenantId?: string;
  name?: string;
  orgName?: string;
  assetEquipmentId?: string;
  assetId?: string;
  assetName: string;
  vendorId?: string;
  vendorName?: string;
  scheduledDate?: string;
  status?: string;
  calibrationId?: string;
  certificateId?: string;
  certificatePath?: string;
  modifiedAt?: string;
  organization?: string
};

type peginatedResponseappointment = {
  data: Appointment[]
  totalCount: number
}

export type CreateAppointmentPayload = {
  assetId: string;
  assetName: string;
  scheduledDate: Date | string;
  status: string;
};

export const appointmentRepository = {
  // get appointments 
  getAppointments: async (
    pageNumber: number,
    pageSize: number,
    organization?: string,
    search?: string,
    status?: string,
    asset?: string,
    vendor?: string,
    appliedSearch?: string
  ): Promise<{ data: Appointment[]; totalCount: number }> => {
    try {
      const response = await axiosInstance.get(`/api/appointments`, {
        params: {
          pageNumber,
          pageSize,
          organization,
          search,
          status,
          asset,
          vendor,
          appliedSearch
        }
      });

      return response.data; 
    } catch (error: any) {
      if (error.response?.status === 404) {
        return { data: [], totalCount: 0 };
      }
      throw error;
    }
  },

  postAppointment(payload: CreateAppointmentPayload) {
    return axiosInstance.post("/api/appointments", payload);
  },

  getappointmentById: async (id: string): Promise<Appointment> => {
    const { data } = await axiosInstance.get<Appointment>(`/api/appointments/${id}`);
    return data;
  },

  // PATCH - Update only ScheduledDate
  rescheduleAppointment: async (id: string, scheduledDate: string) => {
    const response = await axiosInstance.patch(`/api/appointments/${id}`, {
      scheduledDate: scheduledDate,
    });
    return response.data;
  },

  // export appointments as CSV 
  exportAppointments: async (params?: {
    search?: string;
    asset?: string;
    vendor?: string;
    status?: string;
    format?: string;
  }): Promise<Blob> => {

    const response = await axiosInstance.get('/api/appointments/export', {
      params: {
        search: params?.search || undefined,
        asset: params?.asset || undefined,
        vendor: params?.vendor || undefined,
        status: params?.status || undefined,
        format: params?.format || 'csv',
      },
      responseType: 'blob',
    });

    return response.data;
  },

  updateAppointmentStatus: async (id: string, status: string) => {
    const response = await axiosInstance.patch(
      `/api/appointments/${id}/status`,
      JSON.stringify(status), // send raw string
      { headers: { "Content-Type": "application/json", }, }
    );
    return response.data;
  },

  reopenAppointment: async (appointmentId: string) => {
    const response = await axiosInstance.patch(
      `/api/appointments/${appointmentId}/reopen`
    );

    return response.data;
  },

};